<template>
  <md-toolbar
    :class="{ 'md-toolbar-absolute md-white md-fixed-top': $route.meta.navbarAbsolute }"
    md-elevation="16"
    style="height: 50px"
    align="Center"
  >
    <div class="md-toolbar-row">
      <div class="md-toolbar-section-start">
        <h3 class="md-title">{{ $route.name }}</h3>
      </div>
      <div class="md-toolbar-section-end">
          <md-list>
          <md-list-item href="#" @click="showSwal('logout-confirmation')">
            <i class="material-icons">exit_to_app</i>
            <p class="hidden-sm">&nbsp;Logout</p>
          </md-list-item>
        </md-list>

        <md-button
          :class="{ toggled: $sidebar.showSidebar }"
          class="md-just-icon md-round md-simple md-toolbar-toggle"
          @click="toggleSidebar">
          <span class="icon-bar" />
          <span class="icon-bar" />
          <span class="icon-bar" />
        </md-button>
      </div>
    </div>
  </md-toolbar>
</template>

<script>
import Swal from "sweetalert2"
import $ from "jquery"
export default {
  data() {
    return {
      selectedEmployee: "",
      employees: []
    }
  },
  methods: {
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize()
      }
    },
    showSwal(type) {
      if (type === "logout-confirmation") {
        Swal.fire({
          title: "LOGOUT",
          text: `Are you sure you want to logout?`,
          //type: "warning",
          showCancelButton: true,
          confirmButtonClass: "md-button md-success",
          cancelButtonClass: "md-button md-info",
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          buttonsStyling: false
        }).then(result => {
          if (result.value) {
            this.$store.dispatch("auth/logout").then(() => {
              sessionStorage.clear()
              this.$router.push({ path: "/" })
            })
          }
        })
      }
    }
  }
}
</script>
